import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import NumberOutlinedSvg from "@ant-design/icons-svg/es/asn/NumberOutlined";
import AntdIcon from "../components/AntdIcon";
var NumberOutlined = function NumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: NumberOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  NumberOutlined.displayName = 'NumberOutlined';
}
export default /*#__PURE__*/React.forwardRef(NumberOutlined);